// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hv-0";
export var actionModalContentContainer = "_hv-1";
export var createTagButton = "_hv-2";
export var footerContainer = "_hv-7";
export var fullWidthDivider = "_hv-3";
export var hasCreateTagButton = "_hv-4";
export var noCreateTagButton = "_hv-5";
export var tagsContainer = "_hv-6";
export var tagsModalContentContainer = "_hv-8";